import React from "react";
import { Outlet } from "react-router-dom";

const Diagnosises = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Diagnosises;
